// @ts-nocheck
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import dayjs from 'dayjs'
import Operations from '../../operations'
import { TASK_STATUS_ICONS } from '../../common/constants'
import { colors, TASK_STATUS_COLORS } from '@lmc/common/constants'
import AnimateHeight from 'react-animate-height'
import PopupModal from './PopupModal'
import Modal from '.'
import { Icon } from '../generic'

type TaskEditModalProps = {
  fields: any
  setFormField: (options: any) => void
  updateItem: (options: any) => void
  fetchDailyTodos: () => void
  fetchRecurringTodos: () => void
  showToast: (options: { title: string }) => void
  isOpen: boolean
}

export class TaskEditModal extends Component<TaskEditModalProps> {
  state = {
    hasUpdatedStatus: false,
  }

  calculateOverdue = (task: any) => {
    return task.status === 'pending' && dayjs(task.date).isBefore(dayjs())
      ? 'overdue'
      : task.status
  }

  handleStatusChange = (value: string) => {
    const { fields, setFormField } = this.props
    const chosenValue = value === 'overdue' ? 'pending' : value.toLowerCase()
    if (chosenValue === fields.status) {
      return null
    }
    if (!this.state.hasUpdatedStatus) {
      this.setState({ hasUpdatedStatus: true })
    }
    setFormField({
      key: 'status',
      value: chosenValue,
    })
  }

  handleNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.props.setFormField({
      key: 'note',
      value: e.target.value,
    })
  }

  handleSubmit = () => {
    const { fields, updateItem } = this.props
    const statusUrls = {
      completed: 'complete',
      pending: 'incomplete',
      skipped: 'skip',
    }

    updateItem({
      url: `list/tasks/${fields._id}/${statusUrls[fields.status]}`,
      onComplete: this.handleComplete,
    })
  }

  handleComplete = () => {
    const { fetchDailyTodos, fetchRecurringTodos, showToast } = this.props
    showToast({ title: 'Updated a To-Do' })
    fetchDailyTodos()
    fetchRecurringTodos()
  }

  renderStatusNote = () => {
    const { fields } = this.props
    return (
      <AnimateHeight
        duration={500}
        height={this.state.hasUpdatedStatus ? 'auto' : 0}
        animateOpacity
      >
        <div style={styles.label}>
          Add a note <span style={{ fontWeight: 300 }}>(Optional)</span>
        </div>
        <textarea
          className="FormInput"
          style={styles.note}
          value={fields.note || ''}
          onChange={(e) => this.handleNoteChange(e)}
        />
      </AnimateHeight>
    )
  }

  renderStatusIcon = (status: string) => {
    const { fields } = this.props
    const chosenStatus = this.calculateOverdue(fields)
    return (
      <div
        key={status}
        id={`status-icon-${status}`}
        style={styles.statusIcon}
        onClick={() => this.handleStatusChange(status)}
      >
        <Icon
          name={TASK_STATUS_ICONS[status]}
          fill={
            chosenStatus === status ? TASK_STATUS_COLORS[status] : colors.grey
          }
          style={styles.icon}
        />
        <span
          style={{
            fontWeight: chosenStatus === status ? 600 : undefined,
          }}
        >
          {_.capitalize(status)}
        </span>
      </div>
    )
  }

  renderStatusSelect = () => {
    const { fields } = this.props
    const chosenStatus = dayjs(fields.date).isBefore(dayjs())
      ? 'overdue'
      : 'pending'
    return (
      <div style={{ paddingBottom: 20 }}>
        <div style={styles.label}>Change Status</div>
        <div style={styles.statuses}>
          {['completed', 'skipped', chosenStatus].map((status) =>
            this.renderStatusIcon(status)
          )}
        </div>
      </div>
    )
  }

  render() {
    const { isOpen, ...formProps } = this.props
    if (!isOpen) return null
    return (
      <PopupModal
        onClose={() => this.setState({ hasUpdatedStatus: false })}
        type="edit"
        list="To-Do"
        onConfirm={this.handleSubmit}
        {...formProps}
      >
        {this.renderStatusSelect()}
        {this.renderStatusNote()}
      </PopupModal>
    )
  }
}

const styles = {
  icon: {
    marginRight: 10,
  },
  label: {
    fontWeight: 'bold',
    paddingBottom: 5,
  },
  note: {
    minHeight: 70,
    maxHeight: 150,
    maxWidth: '100%',
    minWidth: '100%',
  },
  statuses: {
    display: 'flex',
    flexDirection: 'column',
  },
  statusIcon: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    marginTop: 20,
  },
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchDailyTodos: () => dispatch(Operations.fetchDailyTodos()),
    fetchRecurringTodos: () => dispatch(Operations.fetchRecurringTodos()),
  }
}

const wrappedModal = connect(null, mapDispatchToProps)(TaskEditModal)

export default Modal(wrappedModal, 'editTaskStatus')
